export default angular.module('eventix.common.services.apiPathInterceptor',[])
/**
 * @ngdoc service
 * @name eventix.common.services.APIPathInterceptor
 * @description Implements $httpInterceptor methods for prepending the correct API url
 */
/**
 * @ngdoc service
 * @name eventix.common.services.APIPathInterceptorProvider
 * @description Implements $httpInterceptor methods for prepending the correct API url
 */
    .provider('APIPathInterceptor', function() {
        var $$urlPrefix;
        return {
        /**
         * @ngdoc method
         * @name eventix.common.services.APIPathInterceptorProvider#setPrefix
         * @methodOf eventix.common.services.APIPathInterceptorProvider
         * @description Configure the prefix
         * @param {String} urlPrefix A prefix like `//api.eventix.io/v1`
         */
            setPrefix: function(urlPrefix) {
                $$urlPrefix = urlPrefix;
            },
            $get: /*@ngInject*/ function($q) {
                return {
                /**
                 * Prepend URL with API_ROOT where necessary
                 *
                 * @param {Object} config HTTP request configuration object
                 * @returns {Object} HTTP request configuration object
                 */
                    request: function(config) {
                        if(config.url.indexOf('ui-grid') >= 0)
                            return config;
                        if(!/^(https?:)?\/\/|html?$/.test(config.url))
                            config.url = $$urlPrefix + config.url;
                        return config;
                    }
                };
            }
        };
    }).name;
